export default __webpack_public_path__ + "static/media/CalendarActive.a619948c.svg";